import { initializeApp } from "firebase/app";
import { initializeAppCheck, ReCaptchaV3Provider, getToken } from "firebase/app-check";
import { getAnalytics, logEvent, setUserProperties } from "firebase/analytics";
import { getRemoteConfig, fetchAndActivate } from "firebase/remote-config";

const firebaseConfig = {
    apiKey: "AIzaSyCyBGc_OucdDYooQx_DRwPGEcsBVEsmwM0",
    authDomain: "bondz2.firebaseapp.com",
    projectId: "bondz2",
    storageBucket: "bondz2.firebasestorage.app",
    messagingSenderId: "949143240769",
    appId: "1:949143240769:web:9be46f604721e936ff46c0",
    measurementId: "G-729H36ZTQQ"
};

const app = initializeApp(firebaseConfig);

const appCheck = initializeAppCheck(app, {
    provider: new ReCaptchaV3Provider("6LdwAYgrAAAAAFSPsM1ePRmNqHBO-0lAGUqWlWeT"),
    isTokenAutoRefreshEnabled: true, 
});

let analytics;
if (typeof window !== "undefined") {
  analytics = getAnalytics(app);
}

let remoteConfig;
if (typeof window !== "undefined") {
  remoteConfig = getRemoteConfig(app);
  remoteConfig.settings.minimumFetchIntervalMillis = 3600000;
  remoteConfig.defaultConfig = {
    "web_finish_button_test": false,
    "web_question_example_placeholder": false
  };
}

export async function loadRemoteConfig() {
  if (!remoteConfig) return;
  try {
    await fetchAndActivate(remoteConfig);
    await tagActiveExperiments();
    if (analytics) {
      logEvent(analytics, "remote_config_fetch_succeeded");
    }
  } catch (e) {
    if (analytics) {
      logEvent(analytics, "remote_config_fetch_failed", { message: String(e?.message ?? e) });
    }
  }
}

async function tagActiveExperiments() {
  if (!analytics || !remoteConfig) return;
  try {
    const experiments = (await remoteConfig._storage?.getLastSuccessfulFetchResponse?.())?.experiments;
    if (!experiments || experiments.length === 0) return;
    const properties = {};
    for (const { experimentId, variantId } of experiments) {
      properties[`firebase${experimentId}`] = variantId;
      const normalizedId = experimentId.replace(/^_exp_abt_/, "_exp_");
      if (normalizedId !== experimentId) {
        properties[`firebase${normalizedId}`] = variantId;
      }
    }
    setUserProperties(analytics, properties);
  } catch (e) {
  
  }
}

export { analytics, logEvent };

export async function fetchUserData(uid) {
  const appCheckTokenResult = await getToken(appCheck, false);
  const response = await fetch(
    `https://getuserdata-6skytnriyq-uc.a.run.app?uid=${encodeURIComponent(uid)}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "X-Firebase-AppCheck": appCheckTokenResult.token, 
      },
    }
  );
  if (!response.ok) {
    throw new Error(`Error: ${response.statusText}`);
  }
  return await response.json();
}

export async function fetchCustomsData(uid) {
  const appCheckTokenResult = await getToken(appCheck, false);
  const response = await fetch(
    `https://getcustomsdata-6skytnriyq-uc.a.run.app?uid=${encodeURIComponent(uid)}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "X-Firebase-AppCheck": appCheckTokenResult.token, 
      },
    }
  );
  if (!response.ok) {
    throw new Error(`Error: ${response.statusText}`);
  }
  return await response.json();
}

export async function fetchQuizData(q) {
  const appCheckTokenResult = await getToken(appCheck, false);
  const response = await fetch(
    `https://getquizdata-6skytnriyq-uc.a.run.app?q=${encodeURIComponent(q)}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "X-Firebase-AppCheck": appCheckTokenResult.token, 
      },
    }
  );
  if (!response.ok) {
    throw new Error(`Error: ${response.statusText}`);
  }
  return await response.json();
}

export async function fetchQuizzesData(uid) {
  const appCheckTokenResult = await getToken(appCheck, false);
  const response = await fetch(
    `https://getquizzesdata-6skytnriyq-uc.a.run.app?uid=${encodeURIComponent(uid)}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "X-Firebase-AppCheck": appCheckTokenResult.token, 
      },
    }
  );
  if (!response.ok) {
    throw new Error(`Error: ${response.statusText}`);
  }
  return await response.json();
}

export async function createQuiz(data) {
  const appCheckTokenResult = await getToken(appCheck, false);
  const response = await fetch(
      "https://createquiz-6skytnriyq-uc.a.run.app",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Firebase-AppCheck": appCheckTokenResult.token,
      },
      body: JSON.stringify(data),
    }
  );
  if (!response.ok) {
    throw new Error(`Error: ${response.statusText}`);
  }
  const responseData = await response.json();
  return responseData.id;
}

export function trackClick(uid) {
  if (!uid) return;
  getToken(appCheck, false)
    .then((appCheckTokenResult) => fetch(
      "https://trackclick-6skytnriyq-uc.a.run.app",
      {
        method: "POST",
        keepalive: true,
        headers: {
          "Content-Type": "application/json",
          "X-Firebase-AppCheck": appCheckTokenResult.token,
        },
        body: JSON.stringify({ uid }),
      }
    ))
    .catch(() => {});
}

export async function setupCreator(data) {
  const appCheckTokenResult = await getToken(appCheck, false);
  const response = await fetch(
      "https://setupcreator-6skytnriyq-uc.a.run.app",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Firebase-AppCheck": appCheckTokenResult.token,
      },
      body: JSON.stringify(data),
    }
  );
  if (!response.ok) {
    throw new Error(`Error: ${response.statusText}`);
  }
  const responseData = await response.json();
  return responseData.id;
}
